var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import { DEFAULT_ENVIRONMENT_DETAILS } from "../utils/environmentProvider-types";
import { getEnvironmentDetails } from "../utils/environmentProvider-request";
// Use the centralized default, including success
const defaultEnvironmentDetails = Object.assign({}, DEFAULT_ENVIRONMENT_DETAILS);
export const useGetEnvironmentDetails = () => {
    const [data, setData] = useState(defaultEnvironmentDetails);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const response = yield getEnvironmentDetails();
                    if (response && response.success) {
                        setData(Object.assign(Object.assign({}, response), { error: null }));
                    }
                    else if (response && !response.success) {
                        setData(Object.assign(Object.assign({}, response), { errorMessage: response.errorMessage || "Failed to fetch environment details", error: response.errorMessage || "Failed to fetch environment details" }));
                        console.error("Error fetching environment details");
                    }
                    else {
                        setData(Object.assign(Object.assign({}, data), { errorMessage: "Failed to fetch environment details", error: "Failed to fetch environment details", success: false }));
                        console.error("Error fetching environment details: Unknown error");
                    }
                }
                catch (error) {
                    setData(Object.assign(Object.assign({}, data), { errorMessage: "Failed to fetch environment details", error: error instanceof Error ? error.message : String(error), success: false }));
                    console.error("Error fetching environment details:", error);
                }
                finally {
                    setLoading(false);
                }
            });
            fetchData();
        }
        return () => {
            mounted = false;
        };
    }, []);
    return { data, loading };
};
